import Button from "@weave-design/button";
import {
    toDomainLouvreCurtainCircularCutouts,
    toDomainLouvreCurtainRectangularCutouts,
} from "../../../panels/panelLouvreSourceDefinitionFactory";
import type { LouvreCurtainCutouts } from "@dextall/louvre-curtain-cutout-2d-editor";
import eventBus from "../../../eventBus/eventDispatcher";
import "./louvreCutoutsEditorToolbar.css";

type Props = {
    panelTypeId: string;
    louvreIndex: number;
    cutouts: LouvreCurtainCutouts;
    isSaveAvailable: boolean;
};

export const LouvreCutoutsEditorToolbar = ({ panelTypeId, louvreIndex, cutouts, isSaveAvailable }: Props) => {
    const saveCutouts = () => {
        eventBus.dispatchEvent({
            type: "Dextall.PanelTypes.UpdateLouvreCutouts",
            payload: {
                panelTypeId: panelTypeId,
                louvreIndex: louvreIndex,
                rectangularCutouts: toDomainLouvreCurtainRectangularCutouts(cutouts.rectangularCutouts),
                circularCutouts: toDomainLouvreCurtainCircularCutouts(cutouts.circularCutouts),
            },
        });
    };

    return (
        <div className="louvre-cutouts-editor-toolbar">
            <Button size="standard" title="Save" type="primary" onClick={saveCutouts} disabled={!isSaveAvailable} />
        </div>
    );
};
